export const savedMessagesKey = 'savedMessages';
export const savedNotesKey = 'savedNotes';
export const enterpriseSavedMessagesKey = 'enterpriseSavedMessages';
export const errorMessage = 'Sorry, something went wrong';
